import { Grid, styled } from '@mui/material';
import { PoolInstance, isInstance } from '@synergy/config';
import { PoolTypography } from '@synergy/components-next';
import { ReactElement } from 'react';

import { SupplierListItem } from '../../../models/supplier-list-item';
import { SupplierListItemBoxAT } from './supplier-list-item-box/supplier-list-item-box-AT';
import { SupplierListItemBoxCH } from './supplier-list-item-box/supplier-list-item-box-CH';

const Label = styled(PoolTypography)(() => ({
    height: 60,
    display: 'flex',
    alignItems: 'end',
}));

const LabelGrid = styled(Grid)(() => ({
    '&:first-child > h4': {
        height: 'unset',
    },
}));

export const SupplierDirectoryRow = ({ item }: { item: SupplierListItem | string }): ReactElement => {
    if (typeof item === 'string') {
        return (
            <LabelGrid item={true} xs={12}>
                <Label variant="h4">{item}</Label>
            </LabelGrid>
        );
    }

    return (
        <Grid item={true} xs={12} sm={6}>
            {isInstance(PoolInstance.CH) ? (
                <SupplierListItemBoxCH item={item} />
            ) : (
                <SupplierListItemBoxAT item={item} />
            )}
        </Grid>
    );
};
